module.exports = __webpack_public_path__ + "8d69c737f0d368c65eac1ff0978e1f9f.pdf";